<div class="container">
  <div style="display: flex;justify-content: center" class="row vh-100 align-items-center">
    <div class="col-sm-8 col-md-6 col-lg-4 bg-white rounded p-4 shadow">
      <div class="row justify-content-center mb-4">
        <img class="w-75" src="./assets/img/brand/DnH_primary_logo_pos_RGB.png" alt="logo"  />
      </div>
      <h3 class="text-center">Register Organization</h3>
      <form [formGroup]="preRegisterForm" (ngSubmit)="onSubmit()">
        <div class="container py-3">
          <div class="form-group">
            <input
              type="text"
              class="form-control form-control-underline"
              id="customInput"
              [ngClass]="{ 'is-invalid': preRegisterForm.get('name')?.invalid && preRegisterForm.get('name')?.touched }"
              formControlName="name"
              placeholder=""
            >
            <div *ngIf="preRegisterForm.get('name')?.touched && preRegisterForm.get('name')?.invalid" class="invalid-feedback">
              <div *ngIf="preRegisterForm.get('name')?.hasError('required')">
                Organization name is required.
              </div>
              <div *ngIf="preRegisterForm.get('name')?.hasError('maxlength')">
                Organization name cannot exceed 160 characters.
              </div>
            </div>


          </div>
          <input
            type="submit"
            class="btn btn-primary btn-block"
            id="submitButton"
            value="Continue"
            [disabled]="preRegisterForm.invalid"
          >
        </div>
      </form>

    </div>
  </div>
</div>
